<template>
    <div id="formDescription" class="content-course-box__description-editor">
        <!--        <div class="content-course-box__description-editor-title block-title">Описание</div>-->
        <div class="content-course-box__description-editor-content">
            <platform-editor
                :richEditorOptions="descriptionEditorOptions"
                v-model="prevDescription"
                title="Описание курса"
            ></platform-editor>
        </div>
        <!--       <div class="content-course-box__description-editor-actions">
            <div class="content-course-box__description-editor-action">
                <button type="button" id="resetDescription" class="btn btn_revert" @click="resetDescription">
                    Отменить
                </button>
            </div>
            <div class="content-course-box__description-editor-action">
                <button type="button" id="saveDescription" class="btn" @click="saveDescription">Сохранить</button>
            </div>
        </div>-->
    </div>
</template>

<script>
import Editor from "@/updated/common/components/Editor";
import { richEditorOptionPrimaryPack } from "@/updated/common/constants/rich-editor-options";

export default {
    name: "Description",
    props: ["config", "isEdit"],
    components: { "platform-editor": Editor },
    data() {
        return {
            prevDescription: "",
            descriptionEditorOptions: richEditorOptionPrimaryPack
        };
    },

    methods: {
        resetDescription() {
            this.$emit("emitData", { name: "navigation", to: "v-add-materials" });
        },
        saveDescription() {
            this.$emit("emitData", { name: "saveDesc", text: this.prevDescription });
        }
    }
};
</script>

<style scoped></style>
